 angular
   .module('vppApp')
   .factory('ForgotPasswordService', function() {

    var forgotPasswordService = {
      userName: ''
    };

    return forgotPasswordService;

   });